export default {
  "Audio Compressor": "Audio Kompressor",
  "HitPaw Online Audio Compressor": "HitPaw Online Audio Kompressor",
  "Reduce audio file size online without quality loss.": "Die Audiodateigröße Online ohne Qualitätsverlust reduzieren.",
  "Compress": "Kompresse",
  "Compressing": "Im Prozess von Kompresse",
  "Compressed Successfully": "Erfolgreich komprimiert",
  "Compress New": "Komprimieren Neu",
  "Compression is complete": "Komprimierung ist abgeschlossen",
  "Compression failed": "Komprimierung ist fehlgeschlagen",
  "Quality": "Qualität",
  "Format": "Format",
  "Add file": "Datei hinzufügen",
  "Output Settings": "Ausgabe Einstellungen",

};
